import React, { useState } from "react";
import i18nstring, { strings } from "../../i18n";
import { Button, Modal } from "semantic-ui-react";

const ConfirmationPopup = ({
  title,
  message,
  primaryButtonText,
  onPrimaryButtonClicked,
  open,
  setOpen,
  secondaryButtonText = i18nstring(strings.CANCEL),
  isProcessing = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const isDisabled = isLoading || isProcessing;

  const closeModal = () => {
    if (!isDisabled) {
      setOpen(false);
    }
  };

  const handleClick = async () => {
    if (isDisabled) {
      return;
    }
    setIsLoading(true);
    try {
      const shouldClose = await onPrimaryButtonClicked();
      if (shouldClose !== false) {
        setOpen(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      className="confirmation_popup"
      open={open}
      size="small"
      onClose={closeModal}
      closeOnDimmerClick={!isDisabled}
      closeOnEscape={!isDisabled}
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <p>{message}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          className={"modal-button-cancel"}
          negative
          onClick={closeModal}
          disabled={isDisabled}
        >
          {secondaryButtonText}
        </Button>
        <Button
          className={"modal-button-confirm"}
          positive
          onClick={handleClick}
          disabled={isDisabled}
          loading={isLoading}
        >
          {primaryButtonText}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmationPopup;
